module.exports = __webpack_public_path__ + "img/bg-pattern-circles-dark.3d991652.svg";